import Vue from 'vue'
import { app } from '@/main'
import axios from 'axios'
import moment from 'moment'
import store from '@/store'
import variables from '../utils/variables'

const http = axios.create({
  baseURL: variables.apiBaseUrl,
  timeout: 10000,
  headers: {
    'Accept': 'application/json, text/javascript, */*; q=0.01',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

http.interceptors.request.use(
  config => {
    // let source = axios.CancelToken.source()
    let cancel = !store.state.isOnline
    if (cancel) {
      cancel()
    }

    // if (!config.cancelToken) {
    //   config.cancelToken = source.token
    // }
    config.headers.Identifier = store.state.identifier
    config.headers.ShowFullCatalog = store.state.showFullCatalog
    config.headers.Authorization = `Bearer ${store.getters['AUTH/token']}`

    // Get current timestamp in minutes
    localStorage.setItem('lastApiCall', moment())
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use((response) => {
  let data = response.data
  if (response.headers && response.headers['authorization']) {
    const token = response.headers['authorization'].split(' ')[1]
    if (token) {
      data.auth = { token }
    }
  }

  return Promise.resolve(data)
},
  (error) => {
    if (!store.state.isOnline) {
      return false
    }

    // let axiosRetries = _.get(error.config, 'axios-retry.retries')
    // let axiosRetryCount = _.get(error.config, 'axios-retry.retryCount')
    // let isLastTry = true
    // if (axiosRetries !== undefined && axiosRetryCount !== undefined) {
    //   isLastTry = axiosRetries === axiosRetryCount
    // }

    if (!error.response) {
      const isCanceledRequest = _.get(error, 'message') === 'CANCEL'
      if (!isCanceledRequest) {
        Vue.rollbar.error(error)
        app.helpers.toastError(error)
      }

      return Promise.reject(error)
    }
    if (error.response.status === 403) {
      // Unauthorized response, redirect to login page
      store.dispatch('AUTH/RESET_USER')
        .then(() => {
          if (app.$router.currentRoute.name === 'Login') return
          return app.$router.replace({ 'name': 'Login' }).catch(err => { console.log(err) })
        })
      return Promise.reject(error)
    }

    if ([400, 401, 409, 422].indexOf(error.response.status) !== -1 && typeof error.response.data !== 'undefined') {
      console.log(error.response)
      app.helpers.toastError(error.response.data.data.message)
      return Promise.reject(error.response.data)
    }

    if (_.get(error.response, 'data.message')) {
      app.helpers.toastError(error.response.data.message)
    } else {
      app.helpers.toastError(error.response)
    }
    return Promise.reject(error.response)
  })

export default http



// WEBPACK FOOTER //
// ./src/api/http.js